export const formGlobals = {
    filledClass: 'filled',
    focusedClass: 'focused',
    validClass: 'valid',
    invalidClass: 'invalid',
    errorSelector: '.form_field-error',
    noteSelector: '.form_field-note',
    fieldWrapSelector: '.form_field-wrap',
  };
  